<script>
  import {
    always,
    cond,
    equals,
    T,
  } from 'ramda';
  import { SelectFilter, SelectFilterOption } from '@commercebear/components/Filters';

  export let name;
  export let testid = undefined;
  export let removable = true;

  const print = cond([
    [equals(true), always('Only')],
    [equals('true'), always('Only')],
    [equals(false), always('Exclude')],
    [equals('false'), always('Exclude')],
    [T, always('Include')],
  ]);
</script>

<SelectFilter {name} {testid} {print} {removable}>
  <SelectFilterOption testid='filter-inclusion-include' value={undefined}>Include</SelectFilterOption>
  <SelectFilterOption testid='filter-inclusion-exclude' value={false}>Exclude</SelectFilterOption>
  <SelectFilterOption testid='filter-inclusion-only' value={true}>Only</SelectFilterOption>
</SelectFilter>
